import React from 'react';
import { Container, Row } from 'react-grid-system';
import PropTypes from 'prop-types';

const NewsList = ({ children }) => {
  return (
    <Container>
      <Row>{children}</Row>
    </Container>
  );
};

NewsList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NewsList;
